// extracted by mini-css-extract-plugin
export default {"root":"_3pp5q","left":"_2xt-j","left-side-item-wrapper":"_2yCw8","leftSideItemWrapper":"_2yCw8","right":"_1BVAy","right-side-item-wrapper":"_14KCj","rightSideItemWrapper":"_14KCj"};